import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(() => ({
	roundButton: {
		borderRadius: '50px',
		width: '50px',
		height: '50px',
		minWidth: '50px',
		position: 'fixed',
		right: '50px',
		bottom: '50px',
		'& .MuiButton-endIcon': {
			marginLeft: '0px',
			marginRight: '0px',
		},
		zIndex: 1
	},
}));

interface Props {
	onClick: () => void
}

export const RoundedAddButton = (props: Props) => {
	const classes = useStyles();
	return <Button data-id="showAddTag" className={classes.roundButton} variant="contained" color="primary" onClick={props.onClick} endIcon={<AddIcon />} />;
};
